// App Designer Action Types
export const SET_SELECTED_DEVICE = 'SET_SELECTED_DEVICE';
export const SET_SELECTED_THEME_MODE = 'SET_SELECTED_THEME_MODE';
export const RESET_APP_DESIGNER = 'RESET_APP_DESIGNER';
export const SET_ACTIVE_WIDGET_PREVIEW = 'SET_ACTIVE_WIDGET_PREVIEW';
export const CLEAR_ACTIVE_WIDGET_PREVIEW = 'CLEAR_ACTIVE_WIDGET_PREVIEW';
export const SET_NAVIGATION_PREVIEW = 'SET_NAVIGATION_PREVIEW';
export const CLEAR_NAVIGATION_PREVIEW = 'CLEAR_NAVIGATION_PREVIEW';
export const SET_NAVIGATION_WIDGETS_CACHE = 'SET_NAVIGATION_WIDGETS_CACHE';
export const CLEAR_NAVIGATION_WIDGETS_CACHE = 'CLEAR_NAVIGATION_WIDGETS_CACHE';

// Device types
export const DEVICE_TYPES = {
    MOBILE: 'mobile',
    WEB: 'web',
};

// Theme mode types
export const THEME_MODE_TYPES = {
    LIGHT: 'light',
    DARK: 'dark',
};
